import Marquee from "react-fast-marquee";
import { KeyRound } from "lucide-react";

const ITEMS = [
    "Dépannage 24/7",
    "Intervention 30 min",
    "Devis gratuit",
    "Ouverture de porte 60€ TTC",
    "Agréé assurance",
    "Paris & Île-de-France",
];

export default function EditorialMarquee({ dark = true }) {
    return (
        <div
            data-testid="editorial-marquee"
            className={`relative overflow-hidden border-y py-6 md:py-8 ${
                dark ? "border-white/10 bg-midnight text-white" : "border-midnight/10 bg-white text-midnight"
            }`}
        >
            <Marquee speed={32} gradient={false} pauseOnHover>
                {ITEMS.map((item) => (
                    <span key={item} className="mx-8 flex items-center gap-8 md:mx-12 md:gap-12">
                        <span className="whitespace-nowrap font-display text-2xl font-medium uppercase tracking-tight md:text-4xl">
                            {item}
                        </span>
                        <KeyRound className="h-6 w-6 shrink-0 text-gold md:h-8 md:w-8" strokeWidth={1.8} />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
